const TOKEN_RE = /(\{[A-Z_]+\})/g;

function StepText({ text, values }) {
  return (
    <p className="text-base leading-relaxed text-[#1A1A1A] whitespace-pre-line">
      {text.split(TOKEN_RE).map((part, i) => {
        const isToken = part.startsWith("{") && part.endsWith("}");
        const v = isToken ? values[part.slice(1, -1)] : null;
        if (!v) return <span key={`${i}-${part.slice(0, 12)}`}>{part}</span>;
        if (v.plain) return <span key={`${i}-tok`}>{v.text}</span>;
        return (
          <strong key={`${i}-tok`} data-testid={v.testid} className={v.className || ""}>
            {v.text}
          </strong>
        );
      })}
    </p>
  );
}

export const EtransferSteps = ({ steps, values, testidPrefix }) => (
  <ol className="space-y-5">
    {steps.map((step, idx) => (
      <li key={`${idx}-${step.slice(0, 24)}`} className="flex gap-4" data-testid={`${testidPrefix}-etransfer-step-${idx + 1}`}>
        <span className="shrink-0 w-7 h-7 rounded-full bg-[#8C7B6B] text-[#1A1A1A] text-sm font-bold flex items-center justify-center">
          {idx + 1}
        </span>
        <StepText text={step} values={values} />
      </li>
    ))}
  </ol>
);
